import {
  CURRENT_PIPELINE_VERSION,
  isCurrentPipeline,
  isScoredSession,
  getSessionPipelineVersion,
  isCurrentPipelineSession,
  getResolutionStatus,
  getSessionPriority,
  countUserMessagesByMessageDate
} from '@prosecaptain/sentiment-rules';
import { parseJsonField } from '../utils/parseJsonField';

// Pipeline identity and counting rules live in shared/sentiment-rules, the
// single source of truth for frontend, sentiment worker and mailer-core.
export {
  CURRENT_PIPELINE_VERSION,
  isCurrentPipeline,
  isScoredSession,
  getSessionPipelineVersion,
  isCurrentPipelineSession,
  getResolutionStatus,
  getSessionPriority,
  countUserMessagesByMessageDate
};

export const getSessionEffort = (session) => session?.effort_score ?? session?.intensity_score ?? null;

export const getSessionIntent = (session) => {
  const topics = parseJsonField(session?.overall_sentiment_topics);
  return session?.primary_intent || topics?.primary_intent || topics?.primary_category || null;
};

export const getSessionDelta = (session) => session?.delta_open_to_close ?? session?.delta_valence ?? null;

export const getSessionLoop = (session) => (session?.no_progress_loop ?? session?.loop_detected) === true;

export const isV2Session = (session) => {
  const priority = getSessionPriority(session);
  return priority !== null && priority !== undefined;
};

const SKIP_REASONS = new Set(['too_few_messages', 'no_user_turns']);
const SKIP_TAGS = new Set(['skipped_too_few_messages', 'skipped_no_user_turns']);

const rationaleHasSkipTag = (session) => {
  const rationale = parseJsonField(session?.overall_sentiment_rationale);
  const tags = [
    ...(Array.isArray(session?.tags) ? session.tags : []),
    ...(Array.isArray(rationale?.tags) ? rationale.tags : [])
  ];
  return tags.some((tag) => SKIP_TAGS.has(String(tag).toLowerCase()));
};

export const isTooShortForJudge = (session) => {
  const count = Number(session?.messages_count);
  if (Number.isFinite(count) && count < 3) return true;
  const topics = parseJsonField(session?.overall_sentiment_topics);
  if (SKIP_REASONS.has(topics?.skipped_reason)) return true;
  return rationaleHasSkipTag(session);
};

export const isActionRequiredPriority = (priority) => priority === 'P0' || priority === 'P1';
